/**
 * datepicker.js
 *
 * A reusable wrapper for Air Datepicker v3.
 * Uses translations provided by wp_localize_script ('datepickerTranslations').
 */

import AirDatepicker from 'air-datepicker';
import 'air-datepicker/air-datepicker.css';

/**
 * Initialize Air Datepicker on an element.
 *
 * @param {string|HTMLElement} selector - The input element or its selector.
 * @param {Object}             options  - Optional overrides for Air Datepicker.
 * @returns {AirDatepicker}
 */
export function initDatepicker(selector, options = {}) {
	const el =
		typeof selector === 'string'
			? document.querySelector(selector)
			: selector;
	if (!el) return null;

	// Use translations injected by WordPress
	const t = window.datepickerTranslations || {};

	return new AirDatepicker(el, {
		locale: {
			days: t.days || [],
			daysShort: t.daysShort || [],
			daysMin: t.daysMin || [],
			months: t.months || [],
			monthsShort: t.monthsShort || [],
			today: t.today || 'Today',
			clear: t.clear || 'Clear',
			dateFormat: t.dateFormat || 'yyyy-mm-dd',
			timeFormat: t.timeFormat || 'HH:mm',
			firstDay: typeof t.firstDay !== 'undefined' ? t.firstDay : 1,
		},
		autoClose: true,
		...options,
	});
}
